export default __webpack_public_path__ + "static/media/voucher-card.efaa6e29.png";